/**
 * Constantes do PWA, compartilhadas entre `app/manifest.ts` (splash screen do
 * Android) e o `viewport` de `app/layout.tsx` (barra de status).
 *
 * Vivem juntas porque as duas cores TÊM que bater: o manifest pinta a splash e
 * o `<meta name="theme-color">` pinta a barra de status. Divergir dá um flash
 * de cor errada entre a splash e o primeiro paint, e nada no build reclama.
 */

export const APP_NAME = 'OmniChannel'

/**
 * `--background` do tema escuro (`globals.css:245`, `oklch(0.148 0.004 228.8)`)
 * convertido pra hex. Hex e não o token: o parser de manifest do Android não
 * entende `oklch()` e descarta a cor em silêncio.
 *
 * Cor única (sem par claro/escuro) porque o app nasce no tema escuro
 * (`ThemeProvider defaultTheme="dark"`, `app/layout.tsx`) — casar a barra de
 * status com o tema efetivo do usuário exigiria script no boot, e o custo não
 * se paga enquanto o default é um só.
 */
export const PWA_BACKGROUND_COLOR = '#090b0c'

/** Idem — a barra de status acompanha o chrome do app, não a cor da marca. */
export const PWA_THEME_COLOR = PWA_BACKGROUND_COLOR
